import React from 'react';
import { Link } from 'react-router-dom';
import { usePageMeta } from '../hooks/usePageMeta';

const CookiesPage = () => {
  // Set page meta tags
  usePageMeta({
    title: 'Cookie Policy | BM-Assist.co',
    description: 'Learn about how BM-Assist.co uses cookies and similar technologies. Manage your cookie preferences and understand our data collection practices.',
    ogTitle: 'Cookie Policy | BM-Assist.co',
    ogDescription: 'Information about cookies, tracking technologies, and how to manage your preferences on BM-Assist.co.'
  });

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white border-b border-gray-200 px-4 sm:px-6 lg:px-8 py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold" style={{ color: '#1E3A8A' }}>
            BM-Assist.co
          </Link>
          <Link
            to="/"
            className="text-gray-600 hover:text-blue-900 font-medium flex items-center gap-2"
          >
            ← Back to site
          </Link>
        </div>
      </nav>

      {/* Content */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{ color: '#1E3A8A' }}>
            Cookie Policy
          </h1>
          <p className="text-gray-500 mb-8">Last updated: November 2025</p>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-6">
              We use cookies and similar technologies to make our website work efficiently and to improve your experience. This policy explains what cookies are, what types we use, and how you can control them.
            </p>

            <h3 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#1E3A8A' }}>
              Types of Cookies We Use
            </h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
              <li>
                <strong>Essential Cookies</strong> – Required for the site to function properly.
              </li>
              <li>
                <strong>Performance Cookies</strong> – Help us analyze website traffic and usage.
              </li>
              <li>
                <strong>Functional Cookies</strong> – Remember user preferences and settings.
              </li>
              <li>
                <strong>Marketing Cookies</strong> – Used to track interactions for advertising purposes.
              </li>
            </ul>

            <h3 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#1E3A8A' }}>
              Managing Cookies
            </h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              You can manage or disable cookies through your browser settings or our on-site Cookie Preferences pop-up.
            </p>

            <h3 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#1E3A8A' }}>
              Contact
            </h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              For cookie-related inquiries, email us at{' '}
              <a href="mailto:privacy@bm-assist.co" className="text-blue-600 hover:underline">
                privacy@bm-assist.co
              </a>
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-50 py-8 px-4 sm:px-6 lg:px-8 border-t border-gray-200">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-sm text-gray-600">
            © 2025 BM-Assist.co | All rights reserved |{' '}
            <Link to="/privacy" className="text-blue-600 hover:underline">Privacy Policy</Link> |{' '}
            <Link to="/terms" className="text-blue-600 hover:underline">Terms of Service</Link> |{' '}
            <Link to="/cookies" className="text-blue-600 hover:underline">Cookie Policy</Link>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default CookiesPage;
